import {
	AfterContentChecked,
	AfterViewInit,
	ChangeDetectorRef,
	Component, ElementRef,
	EventEmitter,
	Input, OnChanges,
	OnInit,
	Output,
	SimpleChanges, ViewChild,
	ViewChildren
} from "@angular/core";
import {TableControllerService} from 'src/app/services/table-controller.service';
import {keyExistsIn} from 'src/app/utils/generic';
import * as _ from 'lodash';
import {PageEventType} from '../custom-table-paginator/custom-table-paginator.component';
import {MatDialog} from '@angular/material/dialog';
import {cloneDeep} from "lodash";
import {ActionSet, Data} from "../../../models/layout";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {DataTableSettingsComponent} from "../data-table-settings/data-table-settings.component";
import {ColumnSetting, ColumnSettings} from "../../../app.component";
import {AuthService} from "../../../services/auth.service";

@Component({
  selector: "data-table",
  templateUrl: "./data-table.component.html",
  styleUrls: ["./data-table.component.scss"],
})
export class DataTableComponent implements OnInit, AfterViewInit, AfterContentChecked {
  public ITEM_SIZE = 48;

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  public viewPort?: CdkVirtualScrollViewport;

  @Input()
  pageEvent: PageEventType = {
    pageIndex: 0,
    previousPageIndex: 0,
    loader: 50,
    size: 50,
  };

  @Input()
  length: number = 0;

  @Input()
  numElementsLoaded: number = 0;

  @ViewChildren("checkboxes")
  checkboxes: any;

  itemsArray: any[] = [];

  @Input()
  datasets;

  @Input()
  actionsets?: ActionSet;

  pageable: any;

  @Output()
  onActionEmit: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  onRowClick: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  onResetSort: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  tableController!: TableControllerService;

  @Input()
  disabledColumns: string[] = [];

  @Input()
  defaultCheckedValue: string[] = [];

  @Input()
  disabledActions: { id: string; motivation: string }[] = [];

  @Input()
  isDetail: Boolean = false;

  @Input()
  isSortable: Boolean = true;


  @Input()
  actionsToCheck: string[] = [
    "ACT_DELETE",
    "ACT_CANCEL",
    "ACT_EDIT",
    "ACT_CARD_DOWNLOAD",
    "ACT_CARD_UPLOAD",
    "ACT_SAVE",
    "ACT_SAVE_REWORK",
    "ACT_SHOW_CAMERA",
    "ACT_EDIT_PROBLEM",
    "ACT_EDIT_DAM",
    "ACT_SHOW_DETAIL",
    "ACT_PREVIEW"
  ];


  //ACT_EDIT', 'ACT_ADD', 'ACT_CANCEL
  @Input()
  visibleItems: number = 1;

  @Input()
  showColumnSettings: boolean = false;

  @Input()
  pageReference: string = "";

  @ViewChild("scrollViewport")
  private cdkVirtualScrollViewport;

  @ViewChild("tableTr", {static: false})
  private tableTr?: ElementRef;

  private trWidth = 0;

  public columnSize = {};

  columns = [];

  constructor(
	private authService:AuthService,
    public dialog: MatDialog
  ) {
  }


  ngAfterContentChecked(): void {
    //console.log(this.tableTr)
  }

  ngOnInit(): void {
    this.getDataset();
  }

  ngAfterViewInit() {

    this.tableController.calculateColumnWidth = (table: ElementRef | undefined = this.tableTr) => {
      if (!!table) {
        // const trWidth = table.nativeElement.offsetWidth;
        // [MB 03/10/2024] ITEUR-77: cannot get width from table because grid size can change
        const trWidth = this.viewPort?.elementRef.nativeElement.offsetWidth || table.nativeElement.offsetWidth;

        const totalSizeColumn = (Object.keys(this.tableController.columnWeight).map(key => this.tableController.columnWeight[key]) ?? []).reduce((accumulator, currentValue) => accumulator + currentValue, 1)

        Object.keys(this.tableController.columnWeight).forEach(key => {
          this.tableController.columnSize[key] = Math.floor((totalSizeColumn < trWidth) ? ((trWidth / totalSizeColumn) * this.tableController.columnWeight[key]) : this.tableController.columnWeight[key])
        })

      }

    }

    //this.viewPort?.setTotalContentSize(this.tableController.dataSet.length * this.ITEM_SIZE); // ITEM_SIZE is the height of each item in pixels
  }


  getDataset() {
  }

  onCheckboxClick() {
    /*this.tableController.selectedRow = this.checkboxes
      .toArray()
      .filter((elementRef) => elementRef.nativeElement.checked)
      .map((elementRef) => elementRef.nativeElement.value);

    ////(this.tableController.selectedRow);*/
  }

  editRow(index: number) {
    this.tableController.editRow(index);
  }

  editRowId(index: number, action: string) {
    this.tableController.commitEditDetail(index);


    this.actionEmitter(action + "_ID");
  }

  exitRow(index: number) {
    this.tableController.exitRow(index);
    this.tableController.dataSet = cloneDeep(this.tableController.dataSet);
  }

  commitEdit(index: number, action: string) {
    this.tableController.rowNumber = index;
    if (!this.tableController.dataSet[index].newRow) {
      this.tableController.commitEdit(index);
      this.datasets.datas.forEach((column) => {
        if (
          this.tableController.dataSet[index][column.columnName] !=
          this.tableController.dataSet[index].backup[column.columnName]
        ) {
          this.tableController.dataSet[index]["edited"] = true;
        }
      });
    }
    this.actionEmitter(action);
  }

  keyExistsIn(obj, key) {
    return keyExistsIn(obj, key);
  }

  onInputChange(index: number) {
    ////(this.tableController.dataSet[index]);
    this.tableController.dataSet[index].edited = true;
  }

  onAddClick() {
    ////(this.datasets)
    let newRowObject = {};

    if (
      !!this.tableController.dataSet &&
      this.tableController.dataSet.length > 0 &&
      !!this.tableController.dataSet[0] &&
      Object.keys(this.tableController.dataSet[0]).length > 0
    ) {
      newRowObject = _.cloneDeep(this.tableController.dataSet[0]);
      Object.keys(newRowObject).forEach((key) => {
        if (this.defaultCheckedValue.indexOf(key) > -1) {
          newRowObject[key] = true;
        } else {
          newRowObject[key] = "";
        }
      });
    } else {
      newRowObject = cloneDeep({});
      this.datasets.datas.forEach((column) => {
        if (this.defaultCheckedValue.indexOf(column.columnName) > -1) {
          newRowObject[column.columnName] = true;
        } else {
          newRowObject[column.columnName] = "";
        }
      });
    }

    this.tableController.dataSet = this.tableController.onAddClick(_.cloneDeep(newRowObject));

    this.onRowClick.emit(0);
  }

  deleteRow(index: number, rollback: boolean = false) {
    this.tableController.dataSet = this.tableController.deleteRow(index, rollback);

    if (!rollback) {
      this.actionEmitter("ACT_DELETE_ID");
    } else {
      this.actionEmitter("ACT_ROLLBACK");
    }

    console.log(this.tableController.dataSet);
  }

  cancelClaimRow(index: number, rollback: boolean = false) {
    if (index != -1) {
      this.tableController.dataSet = this.tableController.deleteRow(index, rollback);
      if (!rollback) {
        this.actionEmitter("ACT_WITHDRAW_ID");
      } else {
        this.actionEmitter("ACT_ROLLBACK");
      }
    } else {
      this.tableController.selection.selected.forEach((row) => {
        this.tableController.deletedRows.push(row);
      });
      this.actionEmitter("ACT_WITHDRAW_ID");
    }
  }

  saveRow(index: number, isEditing: Boolean) {
    if (isEditing) {
      this.tableController.commitEdit(index);
    } else {
      this.tableController.dataSet = this.tableController.saveRow(index);
    }
  }

  onCancelClick() {
    this.getDataset();
  }

  onPageChange(pageEvent: any) {
    this.tableController.onPaginationChange.emit(pageEvent);
  }

  actionEmitter(action: string, index?: number) {
    if (action.endsWith("_ALL")) {
      this.tableController.commitEditDetail(-1);
    }
    this.onActionEmit.emit(action);
  }

  convertValue(column: any, dataSetElementElement: any, row: number) {
    return (
      column.optionValues.filter((option) => option.id == dataSetElementElement)[0]?.name ??
      this.tableController.dataSet[row][column.columnName]
    );
  }

  onRadioButtonClick(column: any, i: number) {

    this.tableController.dataSet[i].edited = true;
    this.tableController.dataSet[i][column.columnName] = !this.tableController.dataSet[i][column.columnName];
    column.radioGroup?.forEach((columnName) => {
      this.tableController.dataSet[i][columnName] = !this.tableController.dataSet[i][column.columnName];
    });
    console.log(this.tableController.dataSet[i])
  }

  sortColumn(name: string) {
    let poolMap: Map<string, { order: number; type: "asc" | "desc" }> = new Map();
    this.tableController.sortedColumns.forEach((value, key, map) => {
      poolMap.set(key, value);
    });
    if (
      !!this.tableController.sortedColumns &&
      !!this.tableController.sortedColumns.get(name) &&
      (this.tableController.sortedColumns.get(name)?.type == "asc" ||
        this.tableController.sortedColumns.get(name)?.type == "desc")
    ) {
      poolMap.delete(name);
      if (this.tableController.sortedColumns.get(name)?.type == "asc") {
        const order = this.tableController.sortedColumns.get(name)?.order ?? 0;
        this.tableController.sortedColumns = new Map();
        this.tableController.sortedColumns.set(name, {order: order, type: "desc"});
        poolMap.forEach((value, key, map) => {
          this.tableController.sortedColumns.set(key, value);
        });
      } else {
        const order = this.tableController.sortedColumns.get(name)?.order ?? 0;
        this.tableController.sortedColumns.delete(name);
        this.tableController.sortedColumns.forEach((value, key, map) => {
          this.tableController.sortedColumns.set(key, {
            order: value.order > order ? value.order - 1 : value.order,
            type: value.type,
          });
        });
      }
    } else {
      if (!this.tableController.sortedColumns.get(name)) {
        let maxIndex = 0;
        this.tableController.sortedColumns.forEach((value, key, map) => {
          maxIndex = maxIndex < value.order ? value.order : maxIndex;
        });
        this.tableController.sortedColumns.set(name, {order: maxIndex + 1, type: "asc"});
      }
    }

    this.tableController.onSortChange.emit({
      sorting: this.tableController.sortedColumns,
      pageEvent: this.pageEvent,
    });
  }

  onClearSortClick() {
    this.tableController.sortedColumns = new Map();

    this.tableController.onSortChange.emit({
      sorting: this.tableController.sortedColumns,
      pageEvent: this.pageEvent,
    });
  }

  compare(act: { id: string; motivation: string }, id: string) {
    return act.id == id;
  }

  public get inverseOfTranslation(): string {
    if (!this.viewPort) {
      return "-0px";
    }
    const offset = this.viewPort.getOffsetToRenderedContentStart();

    return `-${offset}px`;
  }

  calculateContainerHeight(): string {
    const numberOfItems = this.tableController.dataSet?.length ?? 1;
    // This should be the height of your item in pixels
    const itemHeight = 48;
    // The final number of items you want to keep visible
    const visibleItems = 3;

    setTimeout(() => {
      // Makes CdkVirtualScrollViewport to refresh its internal size values after
      // changing the container height. This should be delayed with a "setTimeout"
      // because we want it to be executed after the container has effectively
      // changed its height. Another option would be a resize listener for the
      // container and call this line there but it may requires a library to detect
      // the resize event.

      this.cdkVirtualScrollViewport.checkViewportSize();
    }, 300);

    // It calculates the container height for the first items in the list
    // It means the container will expand until it reaches `200px` (20 * 10)
    // and will keep this size.
    if (numberOfItems <= visibleItems) {
      return `${itemHeight * numberOfItems}px`;
    }

    // This function is called from the template so it ensures the container will have
    // the final height if number of items are greater than the value in "visibleItems".
    return `${itemHeight * visibleItems}px`;
  }

  onResetSortClick() {
    this.onResetSort.emit(null)
  }

	get actReportAction(): any {
	  	let actReport = this.actionsets?.actions?.filter(act => act.id === 'ACT_REPORT');
		  if(actReport && actReport.length > 0) {
			  return actReport[0]
		  }else{
			  return null;
		  }

	}

  get actAddLanguage(): any {
    let actReport = this.actionsets?.actions?.filter(act => act.id === 'ACT_ADD_LANGUAGE');
    if(actReport && actReport.length > 0) {
      return actReport[0]
    }else{
      return null;
    }

  }

	get actExportReportAction(): any
	{
		let actReport = this.actionsets?.actions?.filter(act => act.id === 'ACT_EXPORT_REPORT');
		if (actReport && actReport.length > 0)
		{
			return actReport[0];
		}
		else
		{
			return null;
		}
	}

	get actRetryProductionDeclarationImport(): any {
		let actReport = this.actionsets?.actions?.filter(act => act.id === 'ACT_RETRY_PRODUCTION_DECLARATION_IMPORT');
		if(actReport && actReport.length > 0) {
			return actReport[0];
		}else{
			return null;
		}
	}


	get actFixMasterdata(): any {
		let actReport = this.actionsets?.actions?.filter(act => act.id === 'ACT_FIX_MASTERDATA');
		if(actReport && actReport.length > 0) {
			return actReport[0];
		}else{
			return null;
		}
	}

	/**
	 * Opens the column settings dialog for the data table, allowing users to customize visible and hidden columns.
	 * Updates the datasets, session storage, and persists column settings to the backend upon dialog close.
	 * Stops event propagation to prevent unintended side effects.
	 *
	 * @param event MouseEvent that triggers the dialog opening.
	 */
	openColumnSettingsDialog(event: MouseEvent)
	{
		event.stopPropagation();
		const dialogRef = this.dialog.open(DataTableSettingsComponent, {
			data: {
				dataTitle: 'COLUMN_SETTINGS',
				viewList: this.getVisibleColumns().map(hiddenColumn =>
				{
					return { id: hiddenColumn.id, label: hiddenColumn.columnLabel }
				}),
				hideList: this.getHiddenColumns().map(hiddenColumn =>
					{
						return { id: hiddenColumn.id, label: hiddenColumn.columnLabel }
					}),
			},
		});

		dialogRef.afterClosed().subscribe((result) =>
			{
				if (result?.action == 'reset')
				{
					//this.resetFilter();
				}

				if (!!result.hideList)
				{
					const hideList = result.hideList.map((fil) => fil.id);
					const newDatas = [...this.datasets['datas']];
					for(const data of this.datasets['datas']){
						if(hideList.includes(data.id)){
							data.hidden = true;
						}
					}
					this.datasets['datas']= newDatas;

					//Update session storage information
					const columnSetting: ColumnSetting = {hiddenColumns: hideList}
					sessionStorage.setItem(`${this.pageReference}_COLUMN_SETTINGS` , JSON.stringify(columnSetting));

					const columnSettingsString: string | null = sessionStorage.getItem("COLUMN_SETTINGS"); //Contains all column setting for all pages

					let columnSettings = {};
					if(columnSettingsString){
						columnSettings = JSON.parse(columnSettingsString);
					}

					columnSettings = {...columnSettings, [this.pageReference]: columnSetting}

					sessionStorage.setItem(`COLUMN_SETTINGS` , JSON.stringify(columnSettings));

					//Save the objects contains all column settings for all pages in the AUTH DB
					this.authService.setColumnSettings(JSON.stringify(columnSettings)).subscribe();

				}

				if (!!result.viewList)
				{
					const viewList = result.viewList.map((fil) => fil.id);
					const newDatas = [...this.datasets['datas']];
					for(const data of this.datasets['datas']){
						if(viewList.includes(data.id)){
							data.hidden = false;
						}
					}
					this.datasets['datas']= newDatas;
				}
			}
		);
	}

	getVisibleColumns() {
		return this.datasets['datas'].filter(data => data.hidden !== true);
	}

	getHiddenColumns() {
		return this.datasets['datas'].filter(data => data.hidden === true);
	}
}
